import { ReactNode } from "react";
import { NavLink } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

interface MenuItemAnimatedProps {
  to: string;
  icon: ReactNode;
  label: string;
  isExpanded: boolean;
  className?: string;
  visible?: boolean;
}

export function MenuItemAnimated({
  to,
  icon,
  label,
  isExpanded,
  className = "",
  visible = true,
}: MenuItemAnimatedProps) {
  return (
    <>
      {visible && (
        <NavLink
          to={to}
          className={({ isActive, isPending }) =>
            isPending
              ? ""
              : isActive
                ? "text-black"
                : "hover:text-black transition-all"
          }
        >
          <li
            className={`flex items-center py-2 duration-300 gap-3 ${isExpanded ? "px-6" : "px-2"
              } ${className}`}
          >
            <div className="flex-shrink-0">{icon}</div>
            <AnimatePresence>
              {isExpanded && (
                <motion.span
                  initial={{ opacity: 0, width: 0 }}
                  animate={{ opacity: 1, width: "auto" }}
                  exit={{ opacity: 0, width: 0 }}
                  transition={{ duration: 0.2 }}
                  className="whitespace-nowrap overflow-hidden text-xs"
                >
                  {label}
                </motion.span>
              )}
            </AnimatePresence>
          </li>
        </NavLink>)}
    </>
  );
}

